(function ()
{
    'use strict';

    angular
        .module('app')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state)
    {
        window.addEventListener("message", function(event) {   
            if (event.data.type === "iframe") {
                if (event.data.operation === "load-iframe-css") {
                    var link = window.document.createElement("link");
                    link.href = "assets/styles/iframe-styles.css";
                    link.rel = "stylesheet";
                    link.type = "text/css"; 
    
                    window.document.head.appendChild(link);
                } else if (event.data.operation === "abrir-tarefas") {
                    $state.go('app.tarefas.minhas-tarefas');
                } else if (event.data.operation === "signOut") {
                    $state.go('app.login');
                }
            }
        });
    }
})();




